import React, { useMemo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import SocialLinks from '../components/SocialLinks';
import BackToTop from './BackToTop';

/**
 * Footer component displaying site navigation, social links, and ownership information.
 * Designed to be consistent across all pages.
 */
const Footer = () => {
    const settings = useMemo(() => {
        try {
            const storedSettings = localStorage.getItem('settings');
            return storedSettings ? JSON.parse(storedSettings) : {};
        } catch (error) {
            console.error('Error parsing settings from localStorage:', error);
            return {};
        }
    }, []);

    const navItems = useMemo(() => [
        { to: '/', label: 'Home' },
        { to: '/about-me', label: 'About' },
        { to: '/blog', label: 'Blog' },
        { to: '/resume', label: 'Resume' },
        { to: '/certifications', label: 'Certifications' },
        { to: '/connect-me', label: 'Contact' },
    ], []);

    return (
        <>
            <footer id="footer" className="section bg-dark text-muted" role="contentinfo">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={12} className="text-center wow fadeInUp">
                            <SocialLinks />
                        </Col>
                    </Row>

                    <Row className="justify-content-center mt-3">
                        <Col lg={12} className="wow fadeInUp">
                            <nav aria-label="Footer navigation">
                                <ul className="navbar-nav flex-row flex-wrap justify-content-center mb-0">
                                    {navItems.map(({ to, label }) => (
                                        <li key={to} className="nav-item px-2">
                                            <NavLink
                                                to={to}
                                                className={({ isActive }) =>
                                                    `nav-link smooth-scroll${isActive ? ' active' : ''}`
                                                }
                                            >
                                                {label}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </Col>
                    </Row>
                </Container>
            </footer>

            <div className="subfooter bg-dark text-muted py-3">
                <Container>
                    <Row className="align-items-center">
                        <Col
                            lg={6}
                            xs={12}
                            className="text-end text-xs-center wow fadeInUp mb-2 mb-lg-0"
                        >
                            <small>
                                {settings?.copyright || '© Your Name'}
                            </small>
                        </Col>
                        <Col
                            lg={6}
                            xs={12}
                            className="text-start text-xs-center wow fadeInUp"
                        >
                            <small>
                                {settings?.owned_by || 'Owned by You'}
                            </small>
                        </Col>
                    </Row>
                </Container>
            </div>

            <BackToTop offset={200} title={false} />
        </>
    );
};

export default Footer;
